/* Feedogo: shorter watch limits for the live player.
   The page pauses the stream after 5 min without interaction ("Still there?") and after 30 min of
   continuous watching ("Still watching?"). We want 3 min and 15 min. Those limits are constants inside
   the big section file, so instead of editing it we age the player's own timestamps (window.fgSave.lastAct /
   .since) once our shorter limit is reached; the page's 5 s check then pauses exactly as before. */
(function () {
  'use strict';
  var FRAME_ID = 'feedogo-feeder-frame';
  var IDLE_MS = 180000, MAX_MS = 900000;        // ours
  var PAGE_IDLE = 300000, PAGE_MAX = 1800000;   // the page's
  setInterval(function () {
    try {
      var f = document.getElementById(FRAME_ID);
      var w = f && f.contentWindow;
      var fg = w && w.fgSave;
      if (!fg || !fg.active || fg.paused || (w.document && w.document.hidden)) return;
      var n = Date.now();
      if (n - fg.lastAct > IDLE_MS && n - fg.lastAct <= PAGE_IDLE) fg.lastAct = n - PAGE_IDLE - 1;
      if (n - fg.since > MAX_MS && n - fg.since <= PAGE_MAX) fg.since = n - PAGE_MAX - 1;
    } catch (e) {}
  }, 1000);
})();
